import CardMenu from "components/card/CardMenu";
import Card from "components/card";
import * as XLSX from "xlsx";
import { RiFileExcel2Line } from "react-icons/ri";
import { IoPrintOutline } from "react-icons/io5";
import React, { useEffect, useMemo, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ReactSwitch from "react-switch";
import { useDispatch, useSelector } from "react-redux";
import { StockReport, TransactionReport } from "../../../Redux/Report/action";
import { IoEyeSharp } from "react-icons/io5";
import { MdOutlineFilterAlt } from "react-icons/md";
import { MdOutlineFilterAltOff } from "react-icons/md";
import { filter } from "@chakra-ui/system";
import { MdEdit } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { format } from "date-fns";

const TransactionReportpage = () => {
  const navigate = useNavigate();
  const [SelectType, setSelectType] = useState("1");
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());
  const [checked, setChecked] = useState(false);
  const [Filter, setFilter] = useState(false);
  //     const formattedfromDate = new Date(fromDate).toISOString();
  // const formattedtoDate = new Date(toDate).toISOString();
  const [filters, setFilters] = useState({
    BillNumber: "",
    PartyName: "",
    item: "",
    startDate: "",
    endDate: "",
  });
  const fromdate = new Date(fromDate);
  const transactionlist = useSelector((state) =>  Array.isArray(state?.Report?.transaction) ? state.Report.transaction :[]);
  fromdate.setUTCHours(0);
  fromdate.setUTCMinutes(0);
  fromdate.setUTCSeconds(0);

  const formattedfromDate =
    fromdate.toISOString().slice(0, 10) + " 00:00:00.000";
  // console.log(format(fromdate,"yyyy-dd-MM"),"formattedfromDate");
  const todate = new Date(toDate);

  todate.setUTCHours(0);
  todate.setUTCMinutes(0);
  todate.setUTCSeconds(0);
   const [filteredData, setFilteredData] = useState(transactionlist);

  const formattedtoDate = todate.toISOString().slice(0, 10) + " 00:00:00.000";

  // Function to handle input change for filters
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters({
      ...filters,
      [name]: value,
    });
  };

  useEffect(() => {
    // console.log("filters",transactionlist);

    const filtered =
      transactionlist?.length > 0
        ? transactionlist?.filter((item) => {
            return (
              (!filters.BillNumber ||
                item.BillNumber.includes(filters.BillNumber)) &&
              (!filters.BillDate ||
                formatDate(item.BillDate).includes(filters.BillDate)) &&
              (!filters.PartyName ||
                item.PartyName.toLowerCase().includes(
                  filters.PartyName.toLowerCase()
                )) &&
              (!filters.item ||
                item.item.toLowerCase().includes(filters.item.toLowerCase()))
            );
          })
        : [];
    const updatedFiltered = filtered?.map((item) => ({
      ...item,
      selectedType: SelectType,
    }));
    setFilteredData(updatedFiltered);
  }, [filters, transactionlist]);

  const TempleID = JSON.parse(localStorage.getItem("Sopanam_TempleId"));
  const stocklist = useSelector((state) => state.Report.stock);

  // const totalamount =
  // transactionlist.length &&
  // transactionlist?.reduce((total, item) => total + item.BillAmount, 0);

 const totalQuantity = filteredData?.reduce((total, item) => total + Number(item.Quantity || 0), 0);
const totalRate = filteredData?.reduce((total, item) => total + Number(item.rate || 0), 0);
const totalAmount = filteredData?.reduce((total, item) => total + Number(item.Amount || 0), 0);


  const handleChange = (val) => {
    setChecked(val);
  };

  const dispatch = useDispatch();


  useEffect(() => {
    dispatch(
      TransactionReport({
        Type: SelectType,
        TempleId: TempleID,
        From: formattedfromDate,
        To: formattedtoDate,
      })
    );
  }, [formattedfromDate, formattedtoDate, SelectType]);

//   const [hasShownToast, setHasShownToast] = useState(false);

// useEffect(() => {
//   if (!hasShownToast && transactionlist?.length === 0) {
//     toast.error("No data available for the particular date");
    
//   console.log("Component Rendered", transactionlist);
//     setHasShownToast(true);
//   }
//   // Reset the flag when data is present
//   if (transactionlist?.length > 0 && hasShownToast) {
//     setHasShownToast(false);
//   }
// }, [transactionlist, hasShownToast]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    // Pad single digits with leading zeros
    const formattedDay = day < 10 ? `0${day}` : day;
    const formattedMonth = month < 10 ? `0${month}` : month;

    return `${formattedDay}/${formattedMonth}/${year}`;
  };

  const onHandleEditClick = (data) => {
    console.log("clciked", parseInt(data?.selectedType));
    const type = parseInt(data?.selectedType);
    if (type == 2) {
      navigate(`/admin/Purchasepage/${data?.Id}`);
    } else if (type == 1) {
      navigate(`/admin/Sale/${data?.Id}`);
    } else if (type == 6) {
      navigate(`/admin/Returnsale/${data?.Id}`);
    } else if (type == 4) {
      navigate(`/admin/OrderPurchase/${data?.Id}`);
    } else if (type == 7) {
      navigate(`/admin/ReturnPurchase/${data?.Id}`);
    } else if (type == 5) {
      navigate(`/admin/Dispatch/${data?.Id}`);
    } else {
      toast.error("not applicable");
    }
  };

  return (
    <div>
      <Card extra={"w-full h-full p-4"}>
        <div className="relative flex items-center justify-between">
          <div className="pb-5 text-xl font-bold text-navy-700 dark:text-white">
            Transaction Report
          </div>
        </div>
        <div className="relative flex ">
          <div className="mt-4 pb-5">
            <DatePicker
              selected={fromDate}
              onChange={(date) => setFromDate(date)}
              placeholderText="From Date"
              dateFormat="dd/MM/yyyy"
              selectsStart
              className="mr-5"
            />
          </div>
          <div className="mt-4">
            <DatePicker
              selected={toDate}
              onChange={(date) => setToDate(date)}
              placeholderText="To Date"
              selectsEnd
              dateFormat="dd/MM/yyyy"
              className="mr-5"
            />
          </div>
          <div className="mr-6 pb-5 text-xl font-bold text-navy-700 dark:text-white">
            <select
              className="block w-full rounded-lg border border-gray-700 border-green-500 bg-gray-50 p-2.5 text-sm text-gray-900 focus:ring-blue-500 dark:border dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:ring-blue-500"
              id="party"
              value={SelectType}
              onChange={(e) => setSelectType(e.target.value)}
            >
              <option value="0">Select Type</option>
              <option value="1">Issue</option>
              <option value="6">Issue Return</option>
              <option value="2">Purchase</option>
              <option value="4">Purchase Order</option>
              <option value="7">Purchase Return</option>
              <option value="5">Damage</option>
            </select>
          </div>
          <div className="flex w-full  justify-end">
            {Filter ? (
              <MdOutlineFilterAltOff
                size={28}
                onClick={() => {
                  setFilter(false);
                }}
              />
            ) : (
              <MdOutlineFilterAlt
                size={28}
                onClick={() => {
                  setFilter(true);
                }}
              />
            )}
          </div>
        </div>
        {Filter ? (
          <div>
            {" "}
            <div className="mb-4 grid grid-cols-4 gap-4">
              <input
                type="text"
                name="BillNumber"
                value={filters.BillNumber}
                onChange={handleFilterChange}
                placeholder="Filter by Bill No"
                className="border p-2"
              />
              <input
                type="text"
                name="BillDate"
                value={filters.BillDate}
                onChange={handleFilterChange}
                placeholder="Filter by Date"
                className="border p-2"
              />
              <input
                type="text"
                name="PartyName"
                value={filters.PartyName}
                onChange={handleFilterChange}
                placeholder="Filter by Party Name"
                className="border p-2"
              />
              <input
                type="text"
                name="item"
                value={filters.item}
                onChange={handleFilterChange}
                placeholder="Filter by Item Name"
                className="border p-2"
              />
            </div>
          </div>
        ) : (
          ""
        )}
        <div className="h-full md:h-[585px] md:overflow-y-auto ">
          <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
            <table className="w-full text-left text-sm text-gray-500 dark:text-gray-400 rtl:text-right">
              <thead className="bg-gray-50 text-xs uppercase text-gray-700 dark:bg-gray-700 dark:text-gray-400">
                <tr>
                  <th scope="col" className="px-6 py-3">
                    SL NO
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Bill No
                  </th>
                  {SelectType != "1" ? (
                    <>
                      <th scope="col" className="px-6 py-3">
                        Invoice No
                      </th>
                      <th scope="col" className="px-6 py-3">
                        Invoice Date
                      </th>
                    </>):(
                    <>
                    <th scope="col" className="px-6 py-3">
                    Performance Date
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Bill Entered Date
                  </th>
                  </>
                  )}
                  <th scope="col" className="px-6 py-3">
                    Bill Date
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Party Name
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Item Name
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Quantity
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Rate
                  </th>
                  <th scope="col" className="px-6 py-3">
                    Amount
                  </th>
                  {/* <th scope="col" className="px-6 py-3">
                    Actions
                  </th> */}
                  {/* <th scope="col" className="px-6 py-3">
               View
                </th> */}
                </tr>
              </thead>
              <tbody>
                {Array.isArray(filteredData) &&
                  filteredData.map((item, index) => {
                    console.log(filteredData, "filteredData");
                    const BillDate = item.BillDate;
                    const orderDate = item.OrderDate;
                    const Invoicedate = item.OrderDate;
                    const BillEnteredDate=item?.IssueDate
                    const formattedInvoiceDate = formatDate(BillDate);
                    const formattedBillDate = formatDate(BillDate);
                    const PerformanceDate = formatDate(orderDate);
                    const formatedBillEnteredDate=formatDate(BillEnteredDate);
                    return (
                      <tr
                        key={index}
                        className={`border-b ${
                          index % 2 === 0
                            ? "even:bg-gray-50 dark:bg-gray-800"
                            : "odd:bg-white"
                        } ${
                          index % 2 === 0
                            ? "even:bg-gray-800 dark:bg-gray-800"
                            : "odd:bg-gray-900"
                        }`}
                      >
                        <td className="px-6 py-4 text-gray-900">{index + 1}</td>
                        <td className="px-6 py-4 text-gray-900">
                          {item.BillNumber}
                        </td>
                        {SelectType != "1" ? (<><td className="px-6 py-4 text-gray-900">
                          {item.InvoiceNo}
                        </td>
                        <td className="px-6 py-4 text-gray-900">
                          {formattedInvoiceDate}
                        </td></>):(<>
                          <td className="px-6 py-4 text-gray-900">
                          {PerformanceDate}
                        </td>
                          <td className="px-6 py-4 text-gray-900">
                          {formatedBillEnteredDate}
                        </td>
                        </>)}
                        <td className="px-6 py-4 text-gray-900">
                          {formattedBillDate}
                        </td>
                        <td className="px-6 py-4 text-gray-900">
                          {item.PartyName}
                        </td>
                        <td className="px-6 py-4 text-gray-900">{item.item}</td>
                        <td className="px-6 py-4 text-gray-900">
                          {item.Quantity ? item.Quantity.toFixed(3) : "0.000"}
                        </td>
                        <td className="px-6 py-4 text-gray-900">{item.rate}</td>
                        <td className="px-6 py-4 text-gray-900">
                          {item.Amount}
                        </td>
                        {/* <td className="px-6 py-4 text-gray-900">
                          <MdEdit
                            onClick={() => onHandleEditClick(item)}
                            className="cursor-pointer transition-colors duration-200 hover:text-blue-500"
                          />
                        </td> */}
                      </tr>
                    );
                  })}
               <tr className="bg-gray-100 dark:bg-gray-800 font-bold text-gray-900 dark:text-white">
                <td colSpan={7} className="px-6 py-4 text-left">Total</td>
                <td className="px-6 py-4">{totalQuantity.toFixed(3)}</td>
                <td className="px-6 py-4">{totalRate}</td>
                <td className="px-6 py-4">{totalAmount}</td>
              </tr>

              </tbody>
            </table>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default TransactionReportpage;
